/**
 * Mirrors backend/src/utils/leadSpamHeuristics.js for client-side UX (server is authoritative).
 */

function vowelRatio(s) {
  const letters = (s || '').replace(/[^a-z]/gi, '');
  if (letters.length < 4) return 0.35;
  const v = (letters.match(/[aeiouy]/gi) || []).length;
  return v / letters.length;
}

function maxConsonantRun(s) {
  const letters = (s || '').toLowerCase().replace(/[^a-z]/g, '');
  let max = 0;
  let cur = 0;
  for (let i = 0; i < letters.length; i++) {
    if ('aeiouy'.includes(letters[i])) {
      max = Math.max(max, cur);
      cur = 0;
    } else {
      cur += 1;
    }
  }
  return Math.max(max, cur);
}

function looksLikeGibberishNamePart(s, minLen = 10) {
  if (!s || s.trim().length < minLen) return false;
  const t = s.trim();
  const letters = t.replace(/[^a-z]/gi, '');
  if (letters.length < minLen) return false;
  const vr = vowelRatio(t);
  if (vr < 0.14 && letters.length >= 10) return true;
  if (maxConsonantRun(t) >= 6 && letters.length >= 10) return true;
  if (!/\s/.test(t) && /[a-z]/.test(t) && /[A-Z]/.test(t) && t.length >= 14) return true;
  return false;
}

function isSuspiciousFreeMailLocalPart(email) {
  const lower = String(email || '').toLowerCase();
  const m = lower.match(/^([^@]+)@(gmail|googlemail)\.com$/);
  if (!m) return false;
  const local = m[1];
  const dots = (local.match(/\./g) || []).length;
  const parts = local.split('.').filter(Boolean);
  const singleCharParts = parts.filter((p) => p.length === 1).length;
  if (dots >= 4) return true;
  if (dots >= 2 && singleCharParts >= 3) return true;
  return false;
}

function orgLooksLikeGibberish(org) {
  const o = (org || '').trim();
  if (o.length < 14) return false;
  if (!/\s/.test(o) && /^[A-Za-z]+$/.test(o) && /[a-z]/.test(o) && /[A-Z]/.test(o)) return true;
  if (looksLikeGibberishNamePart(o, 12)) return true;
  return false;
}

export function evaluateLeadSpam({ firstName, lastName, email, org }) {
  const reasons = [];

  if (isSuspiciousFreeMailLocalPart(email)) {
    reasons.push('suspicious_freemail_local');
  }

  const firstBad = looksLikeGibberishNamePart(firstName, 8);
  const lastBad = looksLikeGibberishNamePart(lastName, 8);
  if (firstBad && lastBad) {
    reasons.push('name_pair_gibberish');
  } else {
    if (looksLikeGibberishNamePart(firstName, 12)) reasons.push('first_name_gibberish');
    if (looksLikeGibberishNamePart(lastName, 12)) reasons.push('last_name_gibberish');
  }

  if (orgLooksLikeGibberish(org)) {
    reasons.push('org_gibberish');
  }

  if (reasons.includes('suspicious_freemail_local')) {
    return { blocked: true, reasons };
  }
  if (reasons.includes('name_pair_gibberish')) {
    return { blocked: true, reasons };
  }
  if (reasons.length >= 2) {
    return { blocked: true, reasons };
  }

  return { blocked: false, reasons };
}
